// AnimatedRing.jsx
import React, { useEffect, useState } from "react";
import "./AnimatedRing.css"; // Use the plain CSS file

const AnimatedRing = ({ successRatio, countSuccessful, countLocations }) => {
  const [animatedPercent, setAnimatedPercent] = useState(0);

  useEffect(() => {
    let frame = 0;
    const duration = 100; // super snappy
    const totalFrames = Math.round(duration / 16.67);
    const target = Math.round(successRatio * 100);

    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

    const counter = setInterval(() => {
      frame++;
      const progress = Math.min(frame / totalFrames, 1);
      const eased = easeOutCubic(progress);
      const current = Math.round(eased * target);
      setAnimatedPercent(current);

      if (progress === 1) clearInterval(counter);
    }, 16.67);

    return () => clearInterval(counter);
  }, [successRatio]);

  const radius = 54;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - successRatio);

  return (
    <>
      <div className="ringWrapper">
        <svg className="progressRing" viewBox="0 0 120 120">
          <circle className="bg" cx="60" cy="60" r={radius} />
          <circle
            className="fg"
            cx="60"
            cy="60"
            r={radius}
            style={{ "--offset": offset }}
          />
        </svg>
        <div className="centerText">{`${animatedPercent}%`}</div>
      </div>

      <div className="subtext">
        {`${countSuccessful} of ${countLocations} successful`}
      </div>
    </>
  );
};

export default AnimatedRing;

